module.exports = __webpack_public_path__ + "img/20190628160952309.1cbd3893.png";